// Paso 6 — CONFIRMACIÓN
//
// Tick verde, mensaje, botón descargar PDF, botón empezar de nuevo.

import { state, reset } from '/src/shared/state.js';
import { t } from '/src/shared/i18n.js';
import { ctaButton } from '/src/ui/components/cta-button.js';

export function renderStep6(host, { navigateTo }) {
  const email = state.client?.email || 'tu correo';
  const sent = state.emailSent === true;
  const title = sent ? 'Presupuesto enviado' : 'PDF descargado';
  const msg = sent
    ? `Te hemos enviado el presupuesto a <strong>${escapeHtml(email)}</strong>.<br>Una copia ha llegado a info@isinac.com.`
    : `Hemos descargado tu PDF en este dispositivo.<br>Si quieres también lo puedes enviar tú mismo a <strong>info@isinac.com</strong>.`;

  host.innerHTML = `
    <div class="confirm">
      <div class="confirm__tick" aria-hidden="true">${sent ? '✓' : '⬇'}</div>
      <h1 class="step__title" id="step-6-title">${title}</h1>
      <p class="confirm__msg">${msg}</p>

      <div class="confirm__actions" id="confirm-actions"></div>

      <p style="color: var(--c-gray); font-size: 0.85rem;">${t('brand.tagline')}</p>
    </div>
  `;

  const actions = host.querySelector('#confirm-actions');

  const downloadBtn = ctaButton({
    label: 'Descargar PDF',
    variant: 'primary',
    onClick: async () => {
      try {
        let blob = state.pdfBlob;
        // Si el blob se perdió (navegación, recarga…), regeneramos al vuelo.
        if (!blob) {
          downloadBtn.disabled = true;
          const original = downloadBtn.textContent;
          downloadBtn.textContent = 'Generando PDF…';
          try {
            const mod = await import('/src/pdf/generator.js');
            const r = state.room || {};
            const totalPanels = Array.isArray(state.panels) ? state.panels.length : 0;
            const flat = state.results || {};
            const budget = {
              id: 'P-' + Date.now().toString(36).toUpperCase(),
              date: new Date(),
              client: state.client,
              room: {
                largo: r.largo, ancho: r.ancho, altura: r.altura,
                volume: (r.largo || 0) * (r.ancho || 0) * (r.altura || 0),
                totalSurface: 2 * (r.largo || 0) * (r.ancho || 0) +
                              2 * (r.largo || 0) * (r.altura || 0) +
                              2 * (r.ancho || 0) * (r.altura || 0),
              },
              surfaces: state.surfaces,
              product: state.product,
              panels: { ceiling: totalPanels, walls: [0, 0, 0, 0], total: totalPanels },
              results: {
                bands: flat.bands || [],
                trBeforeMean: flat.trBeforeMean || 0,
                trAfterMean: flat.trAfterMean || 0,
                trAt500: { before: flat.trBeforeAt500 || 0, after: flat.trAfterAt500 || 0 },
                trAt1000: { before: flat.trBeforeAt1000 || 0, after: flat.trAfterAt1000 || 0 },
              },
              totalPriceEUR: (state.product?.precio || 0) * totalPanels,
            };
            blob = await mod.generatePDF(budget);
          } finally {
            downloadBtn.disabled = false;
            downloadBtn.textContent = original;
          }
        }
        if (!blob) {
          alert('No hemos podido regenerar el PDF. Vuelve al paso 5 y pulsa Enviar de nuevo.');
          return;
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `presupuesto-isinac-${Date.now()}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (err) {
        console.warn('[step6] descarga falló:', err);
        alert('No se pudo descargar el PDF: ' + (err?.message || 'error desconocido'));
      }
    },
  });

  const restartBtn = ctaButton({
    label: 'Hacer otra simulación',
    variant: 'secondary',
    onClick: () => {
      reset();
      navigateTo(1, { direction: -1 });
    },
  });

  actions.appendChild(downloadBtn);
  actions.appendChild(restartBtn);
}

function escapeHtml(str) {
  return String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
